import Widget from 'common/components/Widget'
import { formatNumber } from 'common/helpers/numeric'
import { LineChart } from 'common/icons'

const Graph = ({ label, value }: { label: string; value: number }) => {
  return (
    <Widget className="w-full block m-auto" type="basic">
      <div className="flex justify-between w-full">
        <div className="flex flex-col gap-2">
          <div className="text-coolGray-400 text-sm font-medium">{label}</div>
          <div className="text-gray-800 text-xl font-bold">
            {formatNumber(value)}
          </div>
        </div>
        <LineChart
          isDefaultColor={false}
          className="text-green-400 self-end h-auto items-end"
          size={28}
        />
      </div>
    </Widget>
  )
}
export default Graph
